import React from 'react';
import Debounce from 'react-debounce-component';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
import css from './prevent-unsaved-box-builder-progress-popup.scss';
const msg = 'Keep in mind, if you cancel, you will lose all of your progress.';
const animationTimeout = 200;
export function PreventUnsavedBoxBuilderProgressPopupComponent({
  open,
  shouldPreventOnLocationChange,
  router,
  route,
  id,
  handleConfirm,
  handleCancel,
  onCancelPopupShown,
  title,
  continueText
}) {
  React.useEffect(() => {
    const skipMessage = JSON.parse(localStorage.getItem('skipMessage'));
    if (!skipMessage && shouldPreventOnLocationChange) {
      window.onbeforeunload = () => msg;
    } else {
      window.onbeforeunload = null;
    }
    router.setRouteLeaveHook(route, nextLocation => {
      if (skipMessage) {
        return true;
      }
      if (shouldPreventOnLocationChange) {
        window.location.href = `${window.location.origin}${nextLocation === null || nextLocation === void 0 ? void 0 : nextLocation.pathname}${nextLocation === null || nextLocation === void 0 ? void 0 : nextLocation.search}`;
        return false;
      }
      return true;
    });
  }, [shouldPreventOnLocationChange]);
  const ContinueText = /*#__PURE__*/React.createElement(Debounce, {
    ms: animationTimeout
  }, continueText);
  const Title = /*#__PURE__*/React.createElement(Debounce, {
    ms: animationTimeout
  }, title);
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    open: open,
    cancelText: ContinueText,
    onConfirm: handleConfirm,
    onCancel: () => handleCancel(onCancelPopupShown, id),
    onClose: () => handleCancel(onCancelPopupShown, id),
    confirmText: "Yes, Cancel",
    dialogClassName: css.dialogClassName,
    msg: msg,
    title: Title,
    showCloseButton: false
  });
}